import(/* webpackMode: "eager" */ "/home/crazysal/sit-a/bd-mobile-next/app/global-error.tsx");
